import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Hidden,
  Drawer,
  Divider,
  Icon,
  Menu as MenuUI,
  MenuItem,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Menu, AccountCircle, Help } from '@material-ui/icons';
import PropTypes from 'prop-types';

import SCAPlus from '~/assets/images/logo.png';
import { Spinner, Navigation, AlertSystem } from '~/components';
import { t } from '~/helpers';
import {
  searchHelperPropertyInNavigationMenu,
  getURLHelper,
} from '~/helpers/helperPDF';
import { signOut } from '~/store/modules/auth/actions';
import {
  requestNavigation,
  toggleDrawer,
} from '~/store/modules/drawer/actions';
import api from '~/services/api';

import { FRENTISTA } from '~/constants/perfil';

import { ChangePassword } from './components';
import { Container, NavBar, Navi, Logo, Main, Avatar } from './styles';

const useStyles = makeStyles(() => ({
  drawerPaper: {
    width: '240px',
  },
}));

function DefaultLayout({ children }) {
  const { innerWidth } = window;
  const { title, navigations, loading, opened } = useSelector(
    (state) => state.drawer
  );

  const { translate } = useSelector((state) => state.language);
  const { profile } = useSelector((state) => state.user);

  const classes = useStyles();
  const dispatch = useDispatch();

  const [width, setWidth] = useState(innerWidth);
  const [items, setItems] = useState([]);
  const [actions, setActions] = useState(null);
  const [password, setPassword] = useState(false);

  /**
   * Toggle drawer
   */
  async function handleToggleDrawer() {
    await dispatch(toggleDrawer(!opened));
  }

  async function handleFormPassword() {
    handleRequestAuditoria();
    setPassword(true);
    setActions(null);
  }

  async function handleRequestAuditoria() {
    await api.post('alterasenhausuario/gravaauditoriaacesso', {
      whereField: [],
      valueWhereField: [],
      typeWhereField: [],
      orderField: '',
      ordination: '',
    });
  }

  useEffect(() => {
    setWidth(innerWidth);
  }, [innerWidth]);

  useEffect(() => {
    const defNavigation = navigations.map((navi) => {
      if (navi.submenus.length === 0) {
        return {
          key: navi.idmenu,
          title: t(navi.codigolabelsistema),
          url: navi.rotamenu,
          icon: <Icon>{navi.iconemenu || 'label'}</Icon>,
        };
      }

      return {
        key: navi.idmenu,
        title: t(navi.codigolabelsistema),
        icon: <Icon>{navi.iconemenu || 'label'}</Icon>,
        children: navi.submenus.map((one) => {
          if (one.submenus.length === 0) {
            return {
              key: one.idmenu,
              title: t(one.codigolabelsistema),
              url: one.rotamenu,
            };
          }

          return {
            key: one.idmenu,
            title: t(one.codigolabelsistema),
            children: one.submenus.map((two) => ({
              key: two.idmenu,
              title: t(two.codigolabelsistema),
              url: two.rotamenu,
            })),
          };
        }),
      };
    });

    setItems(defNavigation);
  }, [navigations, translate]);

  useEffect(() => {
    dispatch(requestNavigation());
  }, [dispatch]);

  return (
    <>
      <AlertSystem />
      <Container open={opened}>
        <CssBaseline />
        <AppBar position="fixed">
          <Toolbar>
            <IconButton color="inherit" onClick={() => handleToggleDrawer()}>
              <Menu />
            </IconButton>

            {/* width: '60%'  */}

            <Typography variant="h6" noWrap style={{ width: '100%' }}>
              {title}
            </Typography>

            {/* <Typography variant="h6" noWrap style={{  width: '100%', justifyContent : 'flex-end' }}>
              {profile.appperfilusuario}
            </Typography> */}

            {searchHelperPropertyInNavigationMenu() && (
              <IconButton
                color="inherit"
                edge="end"
                onClick={() =>
                  window.open(getURLHelper(), '_blank', 'toolbar=yes')
                }
              >
                <Help style={{ fontSize: '2.8rem' }} />
              </IconButton>
            )}

            <IconButton
              color="inherit"
              edge="end"
              onClick={(e) => setActions(e.currentTarget)}
            >
              <Avatar>
                <AccountCircle />
                <div className="description">
                  <p>{profile.name}</p>
                  <small>
                    {profile.appperfilusuario}
                    {profile.glousuarioorganome !== '' &&
                      ` - ${profile.glousuarioorganome}`}
                  </small>
                </div>
              </Avatar>
            </IconButton>
          </Toolbar>
        </AppBar>

        <NavBar open={opened}>
          <Spinner loading={loading} />

          <Hidden smUp implementation="css">
            {width <= 768 && (
              <Drawer
                variant="temporary"
                anchor="left"
                open={opened}
                onClose={() => dispatch(toggleDrawer(false))}
                classes={{ paper: classes.drawerPaper, margin: 0 }}
                ModalProps={{ keepMounted: true }}
              >
                <Navi open={opened}>
                  <Logo open={opened}>
                    <img alt="aguarde a imagem..." src={SCAPlus} />
                  </Logo>
                  <Divider />
                  <Navigation lists={items} />
                </Navi>
              </Drawer>
            )}
          </Hidden>

          <Hidden xsDown implementation="css">
            {width > 768 && (
              <Drawer
                variant="permanent"
                anchor="left"
                className="drawer-desktop"
              >
                <Navi open={opened}>
                  <Logo open={opened}>
                    <img alt="aguarde a imagem..." src={SCAPlus} />
                  </Logo>
                  <Divider />
                  <Navigation lists={items} />
                </Navi>
              </Drawer>
            )}
          </Hidden>
        </NavBar>

        <Main open={opened}>{children}</Main>

        <MenuUI
          anchorEl={actions}
          keepMounted
          open={!!actions}
          onClose={() => setActions(null)}
        >
          {profile.gloperfilid !== FRENTISTA ? (
            <MenuItem onClick={() => handleFormPassword()}>
              {'Alterar Senha'}
            </MenuItem>
          ) : (
            ''
          )}

          <MenuItem onClick={() => dispatch(signOut())}>Sair</MenuItem>
        </MenuUI>

        <ChangePassword password={password} close={() => setPassword(false)} />
      </Container>
    </>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default DefaultLayout;
